var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckedStyle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.7.1.0.1-Onboarding---Position---New-Position",
    transform: "translate(-760.000000, -46.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(760.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-27",
    fill: "#4A4A4A",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Combined-Shape-2-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.68961202,1.00102932e-13 C11.9364675,1.00102932e-13 15.379224,3.44275657 15.379224,7.68961202 C15.3745153,11.9345155 11.9345155,15.3745153 7.68961202,15.379224 C3.44275657,15.379224 -4.12637245e-13,11.9364675 -4.12637245e-13,7.68961202 C-4.12637245e-13,3.44275657 3.44275657,1.00102932e-13 7.68961202,1.00102932e-13 Z M11.3840434,4.92391489 L6.86084272,9.07032457 L4.87606842,7.08555027 C4.66155006,6.86344302 4.34388072,6.77436654 4.04515686,6.85255746 C3.74643301,6.93074837 3.51314303,7.16403835 3.43495212,7.4627622 C3.3567612,7.76148606 3.44583768,8.0791554 3.66794493,8.29367376 L6.23114894,10.8568778 C6.55463594,11.1804159 7.0755735,11.1917161 7.41278598,10.8825098 L12.539194,6.18330246 C12.7641619,5.97695468 12.8619556,5.66626251 12.7957372,5.36826068 C12.7295187,5.07025886 12.5093482,4.83022095 12.2181619,4.7385669 C11.9269755,4.64691286 11.6090113,4.71756711 11.3840434,4.92391489 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckedStyle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkedStyle.ec57a5e36b5f0eb59fceda913bb4d0b7.svg";